import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import BatchInvoice from "./batch-invoice.model";

export default class BatchInvoiceFactory
  implements ObjectBuilderInterface<BatchInvoice> {
  public buildFromJSON(data: { [key: string]: any }): BatchInvoice {
    const value = new BatchInvoice(
      data.invoiceId,
      data.batchPlushieId,
      data.bulkProjectId,
      data.usedDepositPercent,
      data.previouslyInvoicedAmount,
      data.shippingAmount
    );

    value.isNew = false;

    return value;
  }
}
